export function xElem(tagName: string) {
    return document.createElement(tagName);
}
